import React from 'react';
import './Footer.css';

function Footer() {

    const currentYear = new Date().getFullYear();

  return (
    <footer>
        <div id='footer' className='container'>
            <div className='footer-topics'>
                <p className='footer-title'>Família Singular</p>
                <a href='#home' className='footer-text'>Home</a><br />
                <a href='#sobre' className='footer-text'>Sobre nós</a><br />
                <a href='#servicos' className='footer-text'>Serviços</a><br />
                <a href='#profissionais' className='footer-text'>Profissionais</a><br />
                <a href='#espaco' className='footer-text'>Espaço</a><br />
                <a href='#artigos' className='footer-text'>Artigos</a>
            </div>
            <div className='footer-socials'>
            <p className='footer-title'>Redes Sociais</p>
            <a href='http://wa.me/5515991760482' target="_blank" rel="noopener noreferrer">
                <i id='footer-icon' className="fa fa-whatsapp"></i>
            </a>
            <a href='https://www.instagram.com/familiasingular' target="_blank" rel="noopener noreferrer">
                <i id='footer-icon' className="fa fa-instagram"></i>
            </a>
            <a href='mailto:clinicafamiliarsingular@gmail.com'>
                <i id='footer-icon' className="fa fa-envelope"></i>
            </a>
            </div>
            <div className='footer-contact'>
                <p className='footer-title'>Contato</p>
                <a href='http://wa.me/5515991760482' target="_blank" rel="noopener noreferrer" className='footer-text'>(15) 99176-0482<br /></a>
                <a href='https://www.instagram.com/familiasingular' target="_blank" rel="noopener noreferrer" className='footer-text'>@familiasingular<br /></a>
            </div>
            <div className='footer-loc'>
                <p className='footer-title'>Endereço</p>
                <a href='https://maps.app.goo.gl/jxRECXeyTVGPJVDb8' target="_blank" rel="noopener noreferrer" className='footer-text'>Rua Salvador Corrêa, 603<br />Jardim Vergueiro<br />Sorocaba - SP</a>
            </div>
        </div>
        <div className='copyright'>
            &copy; {currentYear} Família Singular. Todos os direitos reservados.
        </div>
    </footer>
  );
}

export default Footer;